<template>
<span class="w-echarts-pie">
  <div id="w-pie"></div>
</span>
</template>

<script>
import * as echarts from 'echarts';
export default {
  props: {
    echartsData: {
      type: Object
    },
    totalRevenue: {
      type: Object
    }
  },
  data() {
    return {
      a: 0,
      b: "",
      img: "/static/images/svolt/w-pieCircle.png",
    };
  },
  mounted() {
    window.addEventListener('resize', () => {
      if (this.myChart) {
        this.myChart.resize();
      }
    })
  },
  methods: {
    reset() {
      this.$nextTick(() => {
        let ct = echarts.getInstanceByDom(document.getElementById('w-pie'));
        if (ct == undefined) {
          ct = echarts.init(document.getElementById('w-pie'));
        }
        this.myChart = ct;
        let tmp = this.init();
        if (tmp) {
          ct.setOption(tmp);
        } else {
          console.log('数据问题chargingStatistics');
        }
      });
    },
    init() {
      this.a = this.totalRevenue.value;
      this.b = "\n总收益(" + this.totalRevenue.unit + ")";
      var rich = {
        black: {
          color: "#19191A",
          fontSize: 10
        },
        din: {
          fontSize: 18,
          fontFamily: 'DINBold',
          fontWeight: 'bold'
        },
        unit: {
          fontSize: 10
        }
      }
      const colorList = ['#F09D3D', '#1060C4', '#19CAE4'];
      let op = {
        color: colorList,
        title: {
          text: '{a|' + this.a + '}{b|' + this.b + '}',
          x: 'center',
          y: 'center',
          textStyle: {
            rich: {
              a: {
                fontSize: 18,
                fontFamily: 'DINBold',
                backgroundColor: 'transparent',
                color: '#000',
                fontWeight: '600',
              },
              b: {
                fontSize: 10,
                backgroundColor: 'transparent',
                color: '#000',
                fontWeight: '600',
              },
            }
          }
        },
        graphic: {
          elements: [{
            type: "image",
            z: 3,
            style: {
              image: this.img,
              width: 75,
              height: 75
            },
            left: 'center',
            top: 'middle'
          }]
        },
        series: [{
            type: "pie",
            hoverAnimation: true,
            hoverOffset: 25,
            startAngle: 180, //起始角度
            clockwise: false, //是否顺时针
            radius: [40, 55],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: true,
              // color: "#000",
              formatter: function (params) {
                return '{black|' + params.data.name + '}\n{din|' + params.data.value + '}{unit|' + params.data.unit + '}';
              },
              rich: rich
            },
            labelLine: {
              show: true,
              length: 10,
              length2: 10
            },
            data: this.echartsData.pieData,
            itemStyle: {
              normal: {
                borderWidth: 10, // 间距的宽度
                // borderColor: 'rgba(40,48,65,1)', //背景色
              }
            },
            zlevel: 30
          },
          { //最内层
            type: 'pie',
            radius: ['0%', '25%'],
            center: ["50%", "50%"],
            hoverAnimation: false,
            clockwise: false,

            itemStyle: {
              normal: {
                color: {
                  type: 'radial',
                  x: 0.5,
                  y: 0.493,
                  r: 0.5,
                  global: false // 缺省为 false
                },
                opacity: 0,
                shadowBlur: 10,
                shadowColor: 'transparent',
              },
            },
            label: {
              show: false
            },
            data: [100]
          },
          { //外发光
            type: 'pie',
            radius: ['40%', '60%'],
            center: ["50%", "50%"],
            hoverAnimation: false,
            clockwise: false,
            itemStyle: {
              normal: {
                borderWidth: 20,
                color: 'transparent',
              }
            },
            label: {
              show: false
            },
            data: [100]
          },
        ]
      };
      return op;
    }
  }
};
</script>

<style lang="scss">
.w-echarts-pie {
  position: relative;
  top: 0px;
  width: 100%;
  height: 100%;
  display: inline-block;
  z-index: 99;

  #w-pie {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/w-echarts-pie.vue